import { useCallback } from 'react';

import { usePreferencesStore } from '#lib/stores/preferencesStore';

const DEFAULT_VIEW_MODE = 'grid';

export default function useCollectionViewMode(scope) {
	const viewMode = usePreferencesStore((s) => s.collectionViewModes[scope] ?? DEFAULT_VIEW_MODE);
	const setCollectionViewMode = usePreferencesStore((s) => s.setCollectionViewMode);
	const setViewMode = useCallback((mode) => setCollectionViewMode(scope, mode), [scope, setCollectionViewMode]);

	return [viewMode, setViewMode];
}
